import { type CommandProperties, createCommand } from '@canvas/rovo-content-bridge-api';

/**
 * @see {@link ShowPaywallCommand}
 */
export interface ShowPaywallCommandProperties extends CommandProperties {
  /**
   * ID of the feature/paywall. Consumed in AFM
   */
  featureId: string;

  /**
   * Position of the paywall. Defaults to 'right'
   */
  position: 'left' | 'right';
  // @ts-ignore - ReactElement in PaywallContent.body is not serializable according to CommandProperties index signature, but it works at runtime
  content: {
    /**
     * Content to show if the user is a site admin. Falls back to default content if not provided
     */
    siteAdmin?: PaywallContent;
    /**
     * Content to show if the user is a regular user
     */
    default: PaywallContent;
  };
}

// Matches packages/paywall/src/paywall-upgrade-service.ts
type PaywallContent = {
  title: string;
  body: string;
  feature: string;
  learnMoreLink: {
    href: string;
    message: string;
  };
  image: {
    src: {
      default: string;
      dark: string;
    };
    alt?: string;
  };
};

/**
 * Command to invoke a paywall in AFM using our new content structure which has both an admin specific view
 * and a regular user view
 */
export const ShowPaywallCommand =
  createCommand<ShowPaywallCommandProperties>('show-paywall-command');

/**
 * @see {@link HidePaywallCommand}
 */
export type HidePaywallCommandProperties = CommandProperties;

/**
 * Command used to notify services that the paywall needs to be hidden
 */
export const HidePaywallCommand =
  createCommand<HidePaywallCommandProperties>('hide-paywall-command');
